import React, { Fragment } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check } from 'lucide-react';
const rows = [{
  without: '3 a 5 horas por semana buscando tips en redes',
  with: '10 minutos al día siguiendo un mapa claro'
}, {
  without: 'Siempre los mismos pensamientos destructivos',
  with: 'Plan de emergencia mental listo para usar'
}, {
  without: 'Crisis por acumulación de estímulos',
  with: 'Mente limpia y enfoque protegido'
}, {
  without: 'Vivir en piloto automático y con queja pasiva',
  with: 'Responsabilidad total y dirección clara'
}, {
  without: 'Cero estructura visible de avance',
  with: 'Sistema directo al próximo nivel emocional'
}];
export function Comparison() {
  return <section className="py-24 md:py-32 px-6 bg-cream text-charcoal" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <FadeIn className="text-center mb-16 md:mb-20" data-id="element-36">
          <div className="inline-flex items-center gap-3 mb-6" data-id="element-37">
            <span className="text-3xl" data-id="element-38">⚖️</span>
            <h2 className="text-sm tracking-widest uppercase text-terracotta font-semibold" data-id="element-39">
              La Realidad
            </h2>
          </div>
          <h3 className="text-3xl md:text-5xl font-serif" data-id="element-40">
            ¿Qué te cuesta <span className="italic" data-id="element-41">NO</span> tenerlo?
          </h3>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-42">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border border-charcoal/10 bg-white" data-id="element-43">
            {/* Headers */}
            <div className="p-6 md:p-8 border-b md:border-b-0 md:border-r border-charcoal/10 bg-charcoal/5" data-id="element-44">
              <h4 className="text-xl font-serif text-center text-charcoal/60" data-id="element-45">
                Sin el Sistema
              </h4>
            </div>
            <div className="p-6 md:p-8 border-b border-charcoal/10 bg-terracotta/5" data-id="element-46">
              <h4 className="text-xl font-serif text-center text-terracotta" data-id="element-47">
                Con el Sistema
              </h4>
            </div>

            {/* Rows */}
            {rows.map((row, i) => <Fragment key={i} data-id="element-48">
                <div className="p-6 md:p-8 border-b md:border-r border-charcoal/10 flex items-start gap-4 bg-charcoal/[0.02]" data-id="element-49">
                  <X className="text-charcoal/30 shrink-0 mt-1" size={20} data-id="element-50" />
                  <p className="text-charcoal/70 leading-relaxed" data-id="element-51">
                    {row.without}
                  </p>
                </div>
                <div className="p-6 md:p-8 border-b border-charcoal/10 flex items-start gap-4" data-id="element-52">
                  <Check className="text-terracotta shrink-0 mt-1" size={20} data-id="element-53" />
                  <p className="font-medium leading-relaxed" data-id="element-54">{row.with}</p>
                </div>
              </Fragment>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}